import { getRequest } from '../../call-center/services/restService';

const getScheduledCallbackService = async hashKey => {
    if (!hashKey) {
        return null;
    }
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const params = `${hashKey}?timezone=${encodeURIComponent(timezone)}`;
    try {
        return new Promise((resolve, reject) => {
            getRequest(`/schedule/lead/${params}`, resolve, reject);
        });
    } catch (error) {
        console.error('Error: ', error);
        return null;
    }
};

export default getScheduledCallbackService;
